/*
 * @Author: your name
 * @Date: 2020-05-25 21:59:49
 * @LastEditTime: 2020-07-03 20:28:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\assets\js\utils.js
 */ 
const Utils = Object.create(null);
// 获取当前时间的上个月
Utils.getPreMon = () => {
    const now = new Date();
    const monthn = now.getMonth();
    const yearn = now.getFullYear();
    let month = monthn;
    let year = yearn;
    if (monthn === 0) {
        month = 12;
        year = year - 1;
    }
    const myDate = new Date(year, month, 0);
    const lastDate = myDate.getDate();
    return { year: year, month: month, lastDate: lastDate };
};
Utils.timeFormat = (date, status, upMonth) => {
    // date: 时间对象
    // status: 获取年月日
    // upMonth = upMonth: 获取上月时间
    const y = date.getFullYear(); // 年
    let m = date.getMonth() + 1; // 月
    let d = date.getDate(); // 日
    m = m > 9 ? m : '0' + m;
    d = d > 9 ? d : '0' + d;
    if (status === 'year') {
        return y;
    } if (status === 'month') {
        if (upMonth === 'upMonth') {
            return m - 1;
        }
        return m;

    } if (status === 'day') {
        return d;
    }
    return `${y}-${m}-${d}`;
};
/*
** 格式化当前时间
var date1 = currentTimeFormat("yyyy-MM-dd");
var date2 = currentTimeFormat("yyyy-MM-dd HH:mm:ss");
*/
Utils.currentTimeFormat = fmt => {
    const date = new Date();
    const o = {
        'M+': date.getMonth() + 1, // 月份 
        'd+': date.getDate(), // 日 
        'H+': date.getHours(), // 小时 
        'm+': date.getMinutes(), // 分 
        's+': date.getSeconds(), // 秒 
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度 
        S: date.getMilliseconds(), // 毫秒 
    };
    if (/(y+)/.test(fmt)) {fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));}
    for (const k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    }
    return fmt;
};
/*
** 当前的前X天
var date1 = theOtherDayTimeFormat("yyyy-MM-dd", 1);
var date2 = theOtherDayTimeFormat("yyyy-MM-dd HH:mm:ss", 1);
*/
Utils.theOtherDayTimeFormat = (fmt, num) => {
    const date = new Date().getTime() - 1000 * 60 * 60 * 24 * num;
    return Utils.timeFormat(new Date(date), fmt);
};

export default Utils;